import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { OrderingSelectOption, SortingType } from 'app/modules/data/modules/catalog-data/components/ordering/models';
import { Store } from '@ngxs/store';
import { ChangeSortingType } from 'app/modules/data/modules/catalog-data/store/catalog-table.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { setLocationQueryParams } from '@utils/other-utils';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@shared/models/locale';
import { CatalogTableState } from '../../store/catalog-table.state';
import { CatalogQueryParams } from '../../models/catalog.service';

@Component({
  selector: 'app-ordering',
  templateUrl: './ordering.component.html',
  styleUrls: ['./ordering.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderingComponent implements OnInit {
  public isOpenSorting = false;
  public icons = CustomIcons;
  public activeSortingName = 'DATA.TABLE_FILTER.ORDERING.BY_NAME_A_Z';

  public options: OrderingSelectOption[] = [
    {
      title: 'DATA.TABLE_FILTER.ORDERING.BY_NAME_A_Z',
      isSelected: true,
      sorting: { byNameCatalog: 'ASC' },
      sortingEn: { byNamePublicCatalogEn: 'ASC' }
    },
    {
      title: 'DATA.TABLE_FILTER.ORDERING.BY_NAME_Z_A',
      isSelected: false,
      sorting: { byNameCatalog: 'DESC' },
      sortingEn: { byNamePublicCatalogEn: 'DESC' }
    },
    {
      title: 'DATA.TABLE_FILTER.ORDERING.BY_CATEGORY_A_Z',
      isSelected: false,
      sorting: { byNameCategory: 'ASC' },
      sortingEn: { byNameOpenCategoryEn: 'ASC' }
    },
    {
      title: 'DATA.TABLE_FILTER.ORDERING.BY_CATEGORY_Z_A',
      isSelected: false,
      sorting: { byNameCategory: 'DESC' },
      sortingEn: { byNameOpenCategoryEn: 'DESC' }
    },
    { title: 'DATA.TABLE_FILTER.ORDERING.BY_ASC_VIEWS', isSelected: false, sorting: { byNumberView: 'ASC' } },
    { title: 'DATA.TABLE_FILTER.ORDERING.BY_DESC_VIEWS', isSelected: false, sorting: { byNumberView: 'DESC' } },
    { title: 'DATA.TABLE_FILTER.ORDERING.BY_DESC_RATING', isSelected: false, sorting: { byRating: 'ASC' } },
    { title: 'DATA.TABLE_FILTER.ORDERING.BY_ASC_RATING', isSelected: false, sorting: { byRating: 'DESC' } }
  ];

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    let sorting = this.route.snapshot.queryParams.sorting;
    if (sorting) {
      const [sortType, direction] = sorting.split('-');
      this.store.dispatch(new ChangeSortingType({ [sortType]: direction } as SortingType, false));
    } else {
      sorting = this.store.selectSnapshot(CatalogTableState.getCatalogSorting);
      if (sorting) {
        const [sortType, direction] = Object.entries(sorting as SortingType)[0];
        sorting = `${sortType}-${direction}`;
        setLocationQueryParams<CatalogQueryParams>({ sorting: sorting }, this.router, this.location);
      }
    }

    if (sorting) {
      this.options.forEach(option => {
        const [sortType, direction] = Object.entries(option.sorting)[0];
        if (sorting === `${sortType}-${direction}`) {
          this.options.forEach(option => (option.isSelected = false));
          option.isSelected = true;
          this.activeSortingName = option.title;
        }
      });
    }
  }

  public chooseOption(option: OrderingSelectOption): void {
    this.activeSortingName = option.title;
    let sort = option.sorting;
    if ((this.translateService.currentLang as Locale) === Locale.EN_US && option.sortingEn) {
      sort = option.sortingEn;
    }
    this.store.dispatch(new ChangeSortingType(sort, true));
    this.options.forEach(option => (option.isSelected = false));
    option.isSelected = true;
    this.isOpenSorting = false;
  }
}
